import React from 'react';
import { ColorPropsEnum } from '../../types';
export var IconClockTimeArrow_1 = _ref => {
  var {
    size,
    strokeWidth = 1.5,
    color = ColorPropsEnum.black
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    version: "1.1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: strokeWidth,
    stroke: color,
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.433 3.067c4.255.715 7.5 4.407 7.5 8.865 0 4.971-4.029 9-9 9 -4.458 0-8.15-3.245-8.865-7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.067 10.433c.095-.565.242-1.11.437-1.634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.197 4.998c-.437.361-.838.762-1.199 1.199"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.433 3.067c-.565.095-1.111.243-1.634.438"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12.391,7 12.391,12.391 8,12.391"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24h-24v-24Z"
  }));
};
//# sourceMappingURL=IconClockTimeArrow_1.js.map